import * as React from 'react'
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { AttachmentClient } from '../../ApiClient';
import { ApiConfig } from '../../ApiConfig';
import TranslatableText from "../../Language/TranslateableText";
import { ApplicationState } from '../../store';
import { fileTypeLabel } from './fileTypeLabel';

interface Props {
    fileId: string;
    fileType?: string;
    createdBy?: string;
    createdOn: string;
    language: any;
}
export const CaseEntryInternalFile: React.FC<Props> = ({ fileId, fileType, createdBy, createdOn }) => {

    async function downloadFile(e: HTMLElement, id: string) {

        let attachmentClient = new AttachmentClient(new ApiConfig());

        await attachmentClient.download(id)
            .then(response => {
                let dataBlob = new Blob([response.data] as any, { type: response.headers!["content-type"] });
                const url = window.URL.createObjectURL(dataBlob);
                // the backend decodes webcam captures to real JPEGs; show images inline
                if (dataBlob.type.startsWith("image/")) {
                    ReactDOM.render(<img src={url} style={{ position: "unset" }} />, e.parentElement);
                } else {
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", id);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            })
            .catch(error => {
                console.log('error downloading..', error);
            });
    };

    return (
        <div>
            <Alert color="secondary"  className="LegalTech-noteBorder ml-5">
                <small>{createdOn} &nbsp; {createdBy}</small>
                <p><TranslatableText translationKey="internal_file" />: &nbsp;
                    <a className="alert-link" style={{ cursor: 'pointer' }} onClick={(e) => downloadFile(e.target as HTMLElement, fileId)}>{fileId}</a>{fileType && <small>&nbsp;({fileTypeLabel(fileType)})</small>}
                </p>
            </Alert>
        </div>
    );
};  

const mapState = (state: ApplicationState) => ({
    language: state && state.language.language_resources
} as Props)

export default connect(mapState)(CaseEntryInternalFile)